import { LUDUM_QUICK_ASSIGN_TYPES } from '@/constants';
import { isAthlete, isCoach } from '@/helpers/rolesHelper';
import get from 'get-object-path';
import { DateTime } from 'luxon';

function squadMembers(squads, userId) {
    const squad = squads.find(({ id }) => id === userId);
    return get(squad, 'squad_users.data') || [];
}

function userRole(users, userId) {
    const user = users.find(({ id }) => id === userId) || {};
    return get(user, 'current_club_roles.data[0].id');
}

const squads = localStorage.getItem('ludum-quick-assign-squads');
const members = localStorage.getItem('ludum-quick-assign-members');
const selectedItems = localStorage.getItem('ludum-quick-assign-selected-items');

export const calendarQuickAssign = {
    namespaced: true,

    state: {
        selectedItems: selectedItems ? JSON.parse(selectedItems) : [],
        filter: {
            squads: squads ? JSON.parse(squads) : [],
            members: members ? JSON.parse(members) : []
        }
    },

    getters: {
        selectedItems(state) {
            return state.selectedItems;
        },

        isEveryBodySelected(state) {
            return state.selectedItems.find(({ type }) => type === LUDUM_QUICK_ASSIGN_TYPES.EVERYBODY);
        },

        selectedAthletes(state, getters, rootState, rootGetters) {
            if (getters.isEveryBodySelected) return rootGetters['clubHelper/clubAthletes'].map(({ id }) => id);

            const athletes = [];
            getters.selectedItems.forEach(({ id, type }) => {
                if (type === LUDUM_QUICK_ASSIGN_TYPES.ATHLETE) {
                    athletes.push(id);
                }

                if (type === LUDUM_QUICK_ASSIGN_TYPES.SQUAD) {
                    const squadUsers = squadMembers(rootGetters['clubHelper/clubSquads'], id);
                    squadUsers.forEach(({ user_id }) => {
                        const roleId = userRole(rootGetters['clubHelper/clubAthletes'], user_id);
                        isAthlete(roleId) && athletes.push(user_id);
                    });
                }
            });

            return [...new Set(athletes)];
        },

        selectedCoaches(state, getters, rootState, rootGetters) {
            if (getters.isEveryBodySelected) return rootGetters['clubHelper/clubCoaches'].map(({ id }) => id);

            const coaches = [];
            getters.selectedItems.forEach(({ id, type }) => {
                if (type === LUDUM_QUICK_ASSIGN_TYPES.COACH) {
                    coaches.push(id);
                }

                if (type === LUDUM_QUICK_ASSIGN_TYPES.SQUAD) {
                    const squadUsers = squadMembers(rootGetters['clubHelper/clubSquads'], id);
                    squadUsers.forEach(({ user_id }) => {
                        const roleId = userRole(rootGetters['clubHelper/clubCoaches'], user_id);
                        isCoach(roleId) && coaches.push(user_id);
                    });
                }
            });

            return [...new Set(coaches)];
        },

        filter(state) {
            return {
                members: state.filter.members,
                squads: state.filter.squads
            };
        }
    },

    mutations: {
        addSelectedItem(state, payload) {
            const index = state.selectedItems.findIndex(({ id, type }) => type === payload.type && id === payload.id);
            index === -1 && state.selectedItems.push(payload);

            localStorage.setItem('ludum-quick-assign-selected-items', JSON.stringify(state.selectedItems));
        },

        removeSelectedItem(state, payload) {
            const index = state.selectedItems.findIndex(({ id, type }) => type === payload.type && id === payload.id);
            index !== -1 && state.selectedItems.splice(index, 1);

            localStorage.setItem('ludum-quick-assign-selected-items', JSON.stringify(state.selectedItems));
        },

        resetCalendarQuickAssignItems(state) {
            state.selectedItems = [];

            localStorage.setItem('ludum-quick-assign-selected-items', JSON.stringify(state.selectedItems));
        },

        setAllSquadsForQuickAssign(state, squads) {
            state.filter.squads = squads;
            localStorage.setItem('ludum-quick-assign-squads', JSON.stringify(state.filter.squads));
        },

        setAlMembersForQuickAssign(state, members) {
            state.filter.members = members;
            localStorage.setItem('ludum-quick-assign-members', JSON.stringify(state.filter.members));
        }
    }
};

export default calendarQuickAssign;
